import { CommissionsComponent } from "@/features/esoPerson/commissions"

export const CommissionsPage = () => {
  return <CommissionsComponent />
}
